import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const navLinks = [
  { to: '/', label: 'nav.home' },
  { to: '/category/meishi', label: 'nav.food' },
  { to: '/category/lvxing', label: 'nav.travel' },
  { to: '/category/shishang', label: 'nav.fashion' },
  { to: '/category/mengchong', label: 'nav.pets' },
  { to: '/about', label: 'nav.about' },
];

export default function Navbar() {
  const { t } = useTranslation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <div className="w-9 h-9 rounded-full bg-primary-500 flex items-center justify-center">
              <i className="ri-heart-fill text-background-50 text-lg"></i>
            </div>
            <span
              className={`text-xl font-bold font-heading transition-colors duration-300 ${
                scrolled || !isHome ? 'text-foreground-900' : 'text-background-50'
              }`}
            >
              蜜桃视频
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  (link.to === '/' ? location.pathname === '/' : location.pathname.startsWith(link.to))
                    ? scrolled || !isHome
                      ? 'bg-primary-100 text-primary-700'
                      : 'bg-background-50/20 text-background-50'
                    : scrolled || !isHome
                      ? 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                      : 'text-background-50/80 hover:text-background-50 hover:bg-background-50/10'
                }`}
              >
                {t(link.label)}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button
              className={`w-9 h-9 rounded-full flex items-center justify-center transition-colors cursor-pointer whitespace-nowrap ${
                scrolled || !isHome
                  ? 'text-foreground-600 hover:bg-background-100'
                  : 'text-background-50/80 hover:text-background-50 hover:bg-background-50/10'
              }`}
              aria-label="搜索"
            >
              <i className="ri-search-line text-lg"></i>
            </button>
            <Link
              to="/about"
              className={`px-5 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                scrolled || !isHome
                  ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                  : 'bg-background-50 text-primary-600 hover:bg-background-100'
              }`}
            >
              下载App
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-9 h-9 rounded-full flex items-center justify-center transition-colors cursor-pointer whitespace-nowrap ${
              scrolled || !isHome
                ? 'text-foreground-900'
                : 'text-background-50'
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/70 py-3 px-4">
            <div className="flex flex-col gap-1">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                    (link.to === '/' ? location.pathname === '/' : location.pathname.startsWith(link.to))
                      ? 'bg-primary-50 text-primary-700'
                      : 'text-foreground-600 hover:bg-background-100'
                  }`}
                >
                  {t(link.label)}
                </Link>
              ))}
              <Link
                to="/about"
                className="mt-2 px-4 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium text-center cursor-pointer"
              >
                下载App
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}